import React, { Component } from "react";
import styled from "styled-components";
import { withStyles } from "@material-ui/core/styles";
import { Icon, Popover, InputAdornment, TextField } from "@material-ui/core";

import { colorPaletteStyles } from "../../themeEditor_style";
import { PREDEFINED_PALETTES } from "common/constants";

const WhiteTextInput = styled(TextField)`
  width: 46%;
  cursor: pointer;
  margin-top: -10px !important;
  & input {
    padding: 10px;
    -webkit-text-fill-color: #333;
    color: #333;
    background-color: transparent;
    &:disabled {
      background-color: transparent;
    }
  }
`;

class ColorPalette extends Component {
    constructor() {
        super();

        this.state = {
            anchorEl: null
        };
    }

    renderPalettes = () => {
        //const palettes = PREDEFINED_PALETTES;
        return PREDEFINED_PALETTES.map((palette, index) => {
            const colors = Object.keys(palette.colors);
            return (
                <div
                    key={index}
                    className={this.props.classes.palette}
                    onClick={() => this.updatePalette(index)}
                >
                    <label className={this.props.classes.label}>
                        {palette.name}
                    </label>
                    <div>
                        <div
                            className={this.props.classes.color}
                            style={{ backgroundColor: palette.colors.theme }}
                        />
                        {colors.map((color, index) => {
                            if (color.startsWith("accent")) {
                                return (
                                    <div
                                        key={index}
                                        className={this.props.classes.color}
                                        style={{
                                            backgroundColor:
                                                palette.colors[color]
                                        }}
                                    />
                                );
                            }
                        })}
                    </div>
                </div>
            );
        });
    };
    updatePalette = paletteIndex => {
        const palette = PREDEFINED_PALETTES[paletteIndex];
        const updateObj = {
            palette_name: palette.id,
            colors: palette.colors
        };
        updateObj.defaultBackgroundColor = [
            "gradient",
            "reverseGradient"
        ].includes(this.props.theme.styleBackground)
            ? "theme"
            : "background_light";
        this.props.update(updateObj);
        this.setState({ anchorEl: null });
    };

    getPaletteName = paletteId => {
        const selectedPalette = PREDEFINED_PALETTES.filter(palette => {
            return palette.id === paletteId;
        });

        const paletteName = selectedPalette[0]
            ? selectedPalette[0].name
            : "Custom";
        return paletteName;
    };

    showPalettes = event => {
        this.state.anchorEl
            ? this.setState({ anchorEl: null })
            : this.setState({ anchorEl: event.currentTarget });
    };

    render() {
        const { theme } = this.props;
        const { anchorEl } = this.state;
        return (
            <div>
                <WhiteTextInput
                    disabled={true}
                    value={this.getPaletteName(theme.palette_name)}
                    variant="outlined"
                    onClick={this.showPalettes}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <Icon>arrow_drop_down</Icon>
                            </InputAdornment>
                        )
                    }}
                />

                <Popover
                    disableEnforceFocus
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: "top",
                        horizontal: "left"
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "left"
                    }}
                    onClose={this.showPalettes}
                >
                    <div style={{ padding: "24px 40px", width: 770 }}>
                        {this.renderPalettes()}
                    </div>
                </Popover>
            </div>
        );
    }
}

export default withStyles(colorPaletteStyles)(ColorPalette);
